﻿import * as Models from '../../models/models';
import {IPaymentMethod} from "../../models/paymentmethod.model";


export class PaymentMethodEditViewModel {

    policyholder: Models.IPolicyholder;
    billingStatement: Models.IBillingStatement;
    cardPaymentMethods: Array<Models.ICardPaymentMethod>;
    echeckPaymentMethods: Array<Models.IEcheckPaymentMethod>;
    selectedPaymentTokenId: string = "";

    public get getPaymentMethods():Array<IPaymentMethod> {

        let paymentMethods = [];
        paymentMethods = paymentMethods.concat(<Array<IPaymentMethod>>this.cardPaymentMethods);
        paymentMethods = paymentMethods.concat(<Array<IPaymentMethod>>this.echeckPaymentMethods);
        return paymentMethods;
    }

    public doCardPaymentMethodsExist = (): boolean => {

        if (typeof (this.cardPaymentMethods) != "undefined") {

            if (this.cardPaymentMethods.length > 0) {
                return true;
            }
        }
        return false;
    };

    public doEcheckPaymentMethodsExist = (): boolean => {

        if (typeof (this.echeckPaymentMethods) != "undefined") {

            if (this.echeckPaymentMethods.length > 0) {
                return true;
            }
        }

        return false;
    };

    public doPaymentMethodsExist = (): boolean => {

        if (this.doCardPaymentMethodsExist()) {
            return true;
        }

        if (this.doEcheckPaymentMethodsExist()) {

            return true;
        }

        return false;
    }

}
